import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Department, DepartmentValue } from '../models';

export const departmentActions = createActionGroup({
    source: 'Department',
    events: {
        'Get Department': props<{ id: string }>(),
        'Get Department Success': props<{ payload: Department }>(),
        'Get Department Error': props<{ code: number }>(),

        'Create Department': props<{ value: DepartmentValue }>(),
        'Create Department Success': props<{ payload: Department }>(),
        'Create Department Error': props<{ code: number }>(),

        'Update Department': props<{ id: string; value: DepartmentValue }>(),
        'Update Department Success': props<{ payload: Department }>(),
        'Update Department Error': props<{ code: number }>(),

        'Delete Department': props<{ id: string }>(),
        'Delete Department Success': props<{ id: string }>(),
        'Delete Department Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
